import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Theme, Typography, makeStyles } from '@material-ui/core'
import type { SpecIntelligenceReportHeader } from 'api/graphQL/types/specIntelligence.types'
import React from 'react'
import { formatLocalDateTime } from 'shared/utils/dateUtils'

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        padding: theme.spacing(2, 2.5),
        borderBottom: `1px solid ${theme.palette.divider}`,
        background: 'linear-gradient(90deg, rgba(138,51,194,0.05), rgba(66,63,226,0.03), transparent)',
    },
    eyebrow: {
        fontSize: pxToRem(11),
        fontWeight: 600,
        color: '#6B7280',
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        marginBottom: pxToRem(2),
    },
    runDate: {
        fontSize: pxToRem(22),
        fontWeight: 700,
        color: '#373F4E',
        letterSpacing: '-0.01em',
    },
    runDateTime: {
        color: '#6B7280',
        fontWeight: 500,
    },
    runMeta: {
        fontSize: pxToRem(13),
        color: '#525969',
        marginTop: pxToRem(4),
    },
    runMetaAuthor: {
        fontWeight: 500,
        color: '#373F4E',
    },
}))

/** Props for {@link InsightsRunDetailHeader}. */
export interface InsightsRunDetailHeaderProps {
    /** The currently selected run. */
    report: SpecIntelligenceReportHeader
}

/** Metadata header for the selected SpecIntelligence run: date/time, author, section count, finding count. */
const InsightsRunDetailHeader = ({ report }: InsightsRunDetailHeaderProps) => {
    const classes = useStyles()

    return (
        <div className={classes.container}>
            <Typography component="div" className={classes.eyebrow}>
                Analysis Run
            </Typography>
            <Typography component="div" className={classes.runDate}>
                {formatLocalDateTime(new Date(report.runDate), 'MMM DD, yyyy')}{' '}
                <span className={classes.runDateTime}>at {formatLocalDateTime(new Date(report.runDate), 'hh:mm A')}</span>
            </Typography>
            <Typography component="div" className={classes.runMeta}>
                Run by <span className={classes.runMetaAuthor}>{report.runByName}</span> · {report.sectionCount} sections ·{' '}
                {report.findingCount} finding{report.findingCount === 1 ? '' : 's'}
            </Typography>
        </div>
    )
}

export default InsightsRunDetailHeader
